const language = {
    "title": "Language",
    "data": [
        {
            "name": "Python",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Python.png",
            "url": "https://www.python.org",
        },
        {
            "name": "Javascript",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Javascript.svg",
            "url": "https://www.javascript.com",
        },
        {
            "name": "Golang",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Golang.png",
            "url": "https://golang.org/",
        },
        {
            "name": "C++",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Cpp.png",
            "url": "http://www.cplusplus.com/",
        },
        {
            "name": "C",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/C.svg",
            "url": "https://www.cprogramming.com/",
        },
    ]
}

const backend = {
    "title": "Backend",
    "data": [
        {
            "name": "Django-Python",
            "image": "https://img.icons8.com/color/96/000000/django.png",
            "url": "https://www.djangoproject.com/",
        },
        {
            "name": "NodeJS",
            "image": "https://img.icons8.com/color/96/000000/nodejs.png",
            "url": "https://nodejs.org/en/",
        },
        {
            "name": "Flask-Python",
            "image": "https://seeklogo.com/images/F/flask-logo-44C507ABB7-seeklogo.com.png",
            "url": "https://flask.palletsprojects.com/en/1.1.x/",
        },
        {
            "name": "Echo-Golang",
            "image": "https://avatars3.githubusercontent.com/u/2624634?s=400&v=4",
            "url": "https://echo.labstack.com/",
        },
        {
            "name": "Gin-Golang",
            "image": "https://raw.githubusercontent.com/gin-gonic/logo/master/color.png",
            "url": "https://github.com/gin-gonic/gin",
        },
    ]
}

const frontend = {
    "title": "Frontend",
    "data": [
        {
            "name": "ReactJS",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/React.png",
            "url": "https://reactjs.org/",
        },
        {
            "name": "Redux",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Redux.png",
            "url": "https://redux.js.org/",
        },
        {
            "name": "HTML",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/HTML.svg",
            "url": "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5",
        },
        {
            "name": "CSS",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/CSS.svg",
            "url": "https://developer.mozilla.org/en-US/docs/Learn/CSS",
        },
        {
            "name": "Bootstrap",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Bootstrap.png",
            "url": "https://getbootstrap.com/docs/4.0/getting-started/introduction/",
        },
        {
            "name": "Less",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Less.webp",
            "url": "http://lesscss.org/",
        },
    ]
}

const database = {
    "title": "Database",
    "data": [
        {
            "name": "MySQL",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/MySQL.png",
            "url": "https://www.mysql.com/",
        },
        {
            "name": "MongoDB",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/MongoDB.png",
            "url": "https://www.mongodb.com/",
        },
        {
            "name": "Redis",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Redis.png",
            "url": "https://redis.io/",
        },
        {
            "name": "PostgreSQL",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Postgresql.png",
            "url": "https://www.postgresql.org/",
        },
    ]
}

const hardware = {
    "title": "Electronics",
    "data": [
        {
            "name": "Arduino",
            "image": "https://cdn.iconscout.com/icon/free/png-512/arduino-4-569256.png",
            "url": "https://www.arduino.cc/",
        },
        {
            "name": "Raspberry Pi",
            "image": "https://www.raspberrypi.org/app/uploads/2018/03/RPi-Logo-Reg-SCREEN.png",
            "url": "https://www.raspberrypi.org/",
        },
        {
            "name": "Beaglebone",
            "image": "https://beagleboard.org/static/images/logos/logo/beagleboard-logo/beagleboard-logo.png",
            "url": "https://beagleboard.org/",
        },
        {
            "name": "OpenCV",
            "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/OpenCV_Logo_with_text_svg_version.svg/1200px-OpenCV_Logo_with_text_svg_version.svg.png",
            "url": "https://opencv.org/",
        },
        {
            "name": "AVR Microcontroller",
            "image": "https://image.flaticon.com/icons/svg/2752/2752843.svg",
            "url": "https://en.wikipedia.org/wiki/AVR_microcontrollers",
        },
        {
            "name": "Kicad",
            "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/KiCad-Logo.svg/1200px-KiCad-Logo.svg.png",
            "url": "https://kicad-pcb.org/",
        },
        {
            "name": "Proteus",
            "image": "https://edasim.com/wp-content/uploads/2020/06/edasim-integrating-ideas-logo-proteus.png",
            "url": "https://www.labcenter.com/",
        },
    ]
}

const others = {
    "title": "Others",
    "data": [
        {
            "name": "Git",
            "image": "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
            "url": "https://git-scm.com/",
        },
        {
            "name": "AWS",
            "image": "https://img.icons8.com/color/96/000000/amazon-web-services.png",
            "url": "https://aws.amazon.com/",
        },
        {
            "name": "GCP",
            "image": "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg",
            "url": "https://cloud.google.com/?hl=en",
        },
        {
            "name": "Docker",
            "image": "https://raw.githubusercontent.com/andre-fajar-n/Profile-Page/master/src/images/skills/Docker.svg",
            "url": "https://www.docker.com/",
        },
        {
            "name": "Kubernetes",
            "image": "https://www.vectorlogo.zone/logos/kubernetes/kubernetes-icon.svg",
            "url": "https://kubernetes.io/",
        },
    ]
}

const ListSkills = [
    language,
    backend,
    frontend,
    database,
    hardware,
    others,
]

export default ListSkills;


// WEBPACK FOOTER //
// ./src/data/Skills.js